export const POSTAL_PATTERNS_BY_COUNTRY: { [key: string]: string } = {
    DE: '^\\d{5}$',
    NO: '^\\d{4}$',
    AT: '^\\d{4}$',
};
